import type { FaireProductEntity } from "../../entity_types/product";

export const p_28jsmgwknq: FaireProductEntity = {
  token: "p_28jsmgwknq",
  type: "product",
  name: "Printed Long Sleeve Casual Shirt Set with Pants",
  brandToken: "b_999ccmmbkw",
  brandName: "Halcyon Outfitters®",
  imageUrl:
    "https://cdn.faire.com/fastly/c4b53a02ac62e08d9e124854361e15ce1c05e9349a1753bc276ab382117b66dd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/650eea02cdc07e30dfd68152321300c38e78d31f9ab26416db6b3277a044e4fb.jpeg",
    "https://cdn.faire.com/fastly/43fb61254da4225dc30846ccd86a4104c2cbefa4f7d2d5a72672e4b1fc485f4b.jpeg",
    "https://cdn.faire.com/fastly/d0c9f5698b37797fedc333febfbb45172cfd2cd729888abfb4623e9065492a6c.jpeg",
    "https://cdn.faire.com/fastly/59149fd494f9ed1a5a3b21bcfc75203fca1dfaa786038e68bb1abe9886454dfe.jpeg",
    "https://cdn.faire.com/fastly/a488d604341ae2264c48532d2c938005342c86fc513abc48cf5f930bd7d865c6.jpeg",
    "https://cdn.faire.com/fastly/67ff257ca627a0a2c6aa5e0b132bb30b1d5b40c47200c59eb94eb02e2b18a689.jpeg",
    "https://cdn.faire.com/fastly/f1e57083ba1effa29bc839e2820798fdbb9c4703530376497e18cfde4d5f0e1c.jpeg",
    "https://cdn.faire.com/fastly/29007689bf6a28be938984340648acedf5d011cd2139984e5f79a0af0f3a01eb.jpeg",
    "https://cdn.faire.com/fastly/b5de1c493b5ba25478977ee1a6ee4b18154a2a5365380d8b183d2926b7a1e7c6.jpeg",
    "https://cdn.faire.com/fastly/5a928fba0d6173f8ed3a2a1a3c2e2b28ccca79a101dc8c24cc2cc66d98b0ec5f.jpeg",
  ],
  priceDollars: 22.1,
  description:
    "Material Composition: 95% Polyester\n\nStyle: Business Casual\n\nFeatures: Printed design, Comfortable fit, Versatile for all seasons\n\nThis stylish outfit consists of a long sleeve printed shirt and matching trousers, ideal for creating fashionable looks. Available in multiple colors, this ensemble is perfect for casual outings or relaxed office days.\n\nSizes: S, M, L, XL, 2XL, 3XL. For a looser fit, consider sizing up.\n\nMix and match these pieces for endless outfit options. Made from high-quality polyester, the fabric is soft against the skin and easy to care for.\n",
  tags: [],
  msrpDollars: 44.2,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:48:24.184Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
